module.exports = __webpack_public_path__ + "static/media/check.62124338.svg";